















































import { AuthUserInfoDropdown } from 'mycorems-app-accounts';
import isGranted from '@/auth/isGranted';
import { HasTaskMixin } from '@/mixins';
import RouterLink from '@/routing/RouterLink.vue';
import Logo from './Logo.vue';
import SelectSearchClient from '../account/client/SelectSearchClient.vue';
import AppSupportBtn from '../support/AppSupportBtn.vue';
import UserAccountLogo from '../user/UserAccountLogo.vue';

interface Data {
  selectedClientId: string|null,
}

export default HasTaskMixin.extend({
  data(): Data {
    return {
      selectedClientId: null,
    };
  },
  watch: {
    $route() {
      if (this.$router.currentRoute.name === 'client_dashboard') {
        const { params } = this.$router.currentRoute;
        if (params.clientId !== this.selectedClientId) {
          this.selectedClientId = null;
        }
      } else {
        this.selectedClientId = null;
      }
    },
  },
  methods: {
    isGranted,
  },
  components: {
    'router-link': RouterLink,
    logo: Logo,
    'select-search-client': SelectSearchClient,
    'app-support-btn': AppSupportBtn,
    'user-account-logo': UserAccountLogo,
    'auth-user-info-dropdown': AuthUserInfoDropdown,
  },
});
